import { InputAdornment, TextField, useTheme } from "@mui/material";
import { LockLocked20Px } from "@qubit/autoparts";

import {
  settingsControlFontSize,
  settingsInputMinHeightPx,
  settingsOverviewFormControlMaxWidthPx
} from "~/features/settings/settings.styles";

type Props = {
  id?: string;
  value: string | number;
  "aria-label"?: string;
  maxDigits?: number;
};

export function LockedFieldControl({
  id,
  value,
  "aria-label": ariaLabel,
  maxDigits = 7
}: Props) {
  const theme = useTheme();
  const { palette } = theme;
  const maxWidthByDigits = `calc(${maxDigits}ch + 40px)`;

  return (
    <TextField
      id={id}
      size="small"
      variant="outlined"
      fullWidth
      disabled
      value={value}
      inputProps={{ "aria-label": ariaLabel }}
      sx={{
        width: "100%",
        maxWidth: `min(${settingsOverviewFormControlMaxWidthPx}px, ${maxWidthByDigits})`,
        minWidth: 0,
        "& .MuiOutlinedInput-root": {
          minHeight: settingsInputMinHeightPx,
          alignItems: "center"
        },
        "& .MuiInputBase-input": {
          boxSizing: "border-box",
          paddingTop: "8.5px",
          paddingBottom: "8.5px",
          fontSize: settingsControlFontSize,
          lineHeight: 1.35
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: palette.text.primary,
          color: palette.text.primary,
          opacity: 1
        }
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <LockLocked20Px fill={palette.text.secondary} aria-hidden />
            </InputAdornment>
          )
        }
      }}
    />
  );
}
